import { DataGridProps } from 'libs/mui/data-grid/types/data-grid-props.type';
import { StyledDataGrid } from './cx-data-grid.style';

const CXDataGrid: React.FC<DataGridProps> = ({ ...props }) => {
  return <StyledDataGrid rowHeight={40} columnHeaderHeight={40} {...props} />;
};

export default CXDataGrid;
